module.exports = __webpack_public_path__ + "static/media/logoscreen2kz.39232dbe.pdf";